import Alpine from 'alpinejs';

Alpine.data('minicart', () => ({
  get cart() {
    return Alpine.store('cart');
  },
  get items() {
    return this.cart.items || [];
  },
  get total() {
    return this.cart.total_price || 0;
  },
  open() {
    this.$root.showModal();
  },
  close() {
    this.$root.close();
  },
}));